// extracted by mini-css-extract-plugin
export default {"item":"FutureAppointmentItem_item__amHZX"};